import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { getOperatorRestaurant } from '../api/operator'
import type { OrganizationDto } from '../api/types'
import { SupplierCatalogPage } from '../components/SupplierCatalogPage'
import {
  operatorBuyerPath,
  operatorBuyerPricesImportPath,
  operatorRestaurantsPath,
} from '../operator/paths'

const restaurantLabel = (restaurant: OrganizationDto): string =>
  restaurant.trade_name?.trim() || restaurant.legal_name

/**
 * «Мои прайсы» ресторана глазами оператора: тот же экран, что у покупателя
 * (SupplierCatalogPage в режиме restaurant-my-prices), но по organizationId из URL.
 * Бэкенд разрешает operator/admin работать с чужим private-catalog по organizationId.
 */
export const OperatorRestaurantPricesScreen = () => {
  const { organizationId: organizationIdParam } = useParams()
  const organizationId = Number(organizationIdParam)
  const [restaurant, setRestaurant] = useState<OrganizationDto | null>(null)

  useEffect(() => {
    if (!Number.isFinite(organizationId) || organizationId <= 0) {
      return
    }
    void getOperatorRestaurant(organizationId)
      .then(setRestaurant)
      .catch(() => undefined)
  }, [organizationId])

  if (!Number.isFinite(organizationId) || organizationId <= 0) {
    return (
      <section className="market-page">
        <p className="echat-error">Некорректный идентификатор ресторана.</p>
        <Link to={operatorRestaurantsPath}>К списку ресторанов</Link>
      </section>
    )
  }

  const label = restaurant ? restaurantLabel(restaurant) : null

  return (
    <SupplierCatalogPage
      organizationId={organizationId}
      importPath={operatorBuyerPricesImportPath(organizationId)}
      catalogMode="restaurant-my-prices"
      title="Мои прайсы ресторана"
      description={label ?? undefined}
      showCatalogVersions
      backLink={
        <>
          <Link to={operatorRestaurantsPath}>← Рестораны</Link>
          {' · '}
          <Link to={operatorBuyerPath(organizationId)}>Карточка</Link>
        </>
      }
    />
  )
}
